enum ButtonSizes {
    LG = 'lg',
    MD = 'md',
    SM = 'sm',
    XS = 'xs'
}

export default ButtonSizes;